<template>
  <div class="dflexc-jcs market-place-card"
    v-if="mp.list.length > 0">
    <div class="dflexr-jce info-header">
      <div class="numGuards">
        Market Place Guards: {{ mp?.list[mp_idx].marketGuards}}
      </div>
    </div>
    <section class="dflexr-jcs merchant-info-panel">
      <merchant-list-panel :mp_idx="mp_idx"
      @merch_select="merch_select"/>

      <MerchantCard :merchant="xMerchant"/>
    </section>


  </div>
</template>

<style scoped lang="scss">
@import "@/assets/styles/colors.scss";
  .market-place-card {

    background-color: rgba(64, 140, 119, 0.43);
    color: white;
    margin: 1rem;
    padding: 1rem;
    border-radius: 1rem;
    flex: 1;

    .info-header {
      border-bottom: 1px solid white;
    }

    .merchant-info-panel {
      height: 100%;
    }
  }
</style>

<script setup>
import {computed, inject, onMounted, onUpdated, ref} from "vue";
import MerchantListPanel from "@/components/marketplace/MerchantListPanel.vue";
import MerchantCard from "@/components/marketplace/MerchantCard.vue";


const props = defineProps(['mp_idx'])
const mp = inject('mp_pkg')

const active_merch_idx = ref(-1)
const xMerchant = computed(() => {
  // debugger
  let mIdx = mp.active_merchant_idx[mp.active_mp]
  if(mp.active_merchant_idx[mp.active_mp] >= mp.list[mp.active_mp].merchants.length)
    mIdx = 0
  // return mp.list[props.mp_idx].merchants[active_merch_idx.value]
  return mp.list[mp.active_mp].merchants[mIdx]
})

const merch_select = (merchIdx) => {
  active_merch_idx.value = merchIdx
  mp.active_merchant_idx[mp.active_mp] = merchIdx
}

// let mp = mp_data.list[props.mp_idx]
onMounted(() => {
})

onUpdated(() => {
})

</script>
